import useTrackerStore from "@/stores/trackers";

export function useTracking() {
  const trackerStore = useTrackerStore();

  const trackEvent = (event: string, properties: Record<string, any> = {}) => {
    trackerStore.logRudderstackEvent(event as any, properties);
  };

  const trackSuccess = (event: string, properties: Record<string, any> = {}) => {
    trackEvent(event, { ...properties, success: true });
  };

  const trackError = (event: string, properties: Record<string, any> = {}) => {
    trackEvent(event, { ...properties, success: false });
  };

  return {
    trackEvent,
    trackSuccess,
    trackError,
  };
}
